import _ from 'lodash';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectAutomatedActionCriteria = createSelector(
  getSystem,
  ({ automatedActionCriteria }) => automatedActionCriteria,
);

export const selectAutomatedActionCriteriaSchema = createSelector(
  getSystem,
  ({ automatedActionCriteriaSchema }) => automatedActionCriteriaSchema,
);

export const selectAutomatedActionCriteriaList = createSelector(
  selectAutomatedActionCriteria,
  automatedActions => _.sortBy(Object.values(automatedActions), 'executionOptions.executionOrder'),
);
